import LearnersDetailsContent from 'FunctionalComponents/LearnersDetails/LearnersDetailsContent'
import React from 'react'


const LearnersDetails = () => {
    return (
        <>
            <LearnersDetailsContent />
        </>
    )
}

export default LearnersDetails
